import { KhoDeNghiXuatKhoService } from './../../../chuc-nang-kho/kho-de-nghi-xuat-kho/kho-de-nghi-xuat-kho-service/kho-de-nghi-xuat-kho.service';
import { KhoXuatPageFileComponent } from '../kho-xuat-page-file/kho-xuat-page-file.component';
import { element } from 'protractor';
import { select } from '@ngrx/store';
import {Component,
		OnInit,
		ElementRef,
		ViewChildren,
		ViewChild,
		ChangeDetectionStrategy,
		ChangeDetectorRef,
		Inject,
		HostListener,
		ViewRef
	}
from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { ReplaySubject,BehaviorSubject } from 'rxjs';
//Service

import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';

import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
//Model
import {KhoXuatKho,KhoXuatKhoChiTiet,KhoXuatKhoDeNghi } from '../kho-xuat-kho-page-model/kho-xuat-kho-page.model';

import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import moment from 'moment';
import {KhoXuatKhoPageDSDNComponent } from '../kho-xuat-kho-page-dsdn/kho-xuat-kho-page-dsdn.component';
import {KhoXuatKhoPageDuyetComponent } from '../kho-xuat-kho-page-duyet/kho-xuat-kho-page-duyet.component';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { JsPDFFontService } from '../../../dung-chung/__services/pdf-custom-font.service';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { KhoXuatKhoPageService } from '../kho-xuat-kho-page-service/kho-xuat-kho-page.service';
import { KhoDeNghiXuatKhoDialogDetailComponent } from '../../kho-de-nghi-xuat-kho-page/kho-de-nghi-xuat-kho-dialog-detail/kho-de-nghi-xuat-kho-dialog-detail.component';
import { KDDatHangEditComponent } from '../../../kinh-doanh/kd-dat-hang/kd-dat-hang-edit/kd-dat-hang-edit.component';
import { KDDatHangService } from '../../../kinh-doanh/kd-dat-hang/kd-dat-hang-service/kd-dat-hang.service';
import { FileImport } from '../../../dung-chung/__model/file-import.model';
@Component({
	selector: 'm-kho-xuat-kho-page-dialog',
	templateUrl: './kho-xuat-kho-page-dialog.component.html',
	styleUrls: ['../kho-xuat-kho-page.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class KhoXuatKhoPageDialogComponent implements OnInit {
	/*Config Form */
	CONFIG: CommonConFig;

	/* Các trường focus cho các tag trong form */
	@ViewChildren("focusMaNCC") focusMaNCC;
	@ViewChildren("focusDienGiai") focusDienGiai;
	@ViewChildren("focusThue") focusThue;
	@ViewChildren("focusDKThanhToan") focusDKThanhToan;

	@ViewChild("autosize", { static: true }) autosize: CdkTextareaAutosize;

	/* Trigger menu hiển thị cột cho danh sách */
	@ViewChild("trigger", { static: true }) _trigger: MatMenuTrigger;

	/* Comment columns mat-table
		Các trường columns cho bảng:
		- displayedColumns: display ra form
		- availableColumns: các cột sẽ được add vào display.
		- extendsColumns: các cột mở rộng thêm cho display khi QC kiểm tra
	*/
	displayedColumns = [];
	availableColumnsInit = [];
	availableColumns = [
		// {
		// 	stt: 0,
		//     name: 'select',
		//     displayName: 'Check chọn',
		// 	alwaysChecked: true,
		// 	isShow: true
		// },
		{
			stt: 1,
			name: "#",
			displayName: "#",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 2,
			name: "MAHH",
			displayName: "Mã hàng",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 3,
			name: "TENHH",
			displayName: "Tên hàng",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 4,
			name: "QUYCACH",
			displayName: "Quy cách",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 5,
			name: "DONVITINH",
			displayName: "Đơn vị tính",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 6,
			name: "KHO",
			displayName: "Kho",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 7,
			name: "SOLO",
			displayName: "Số lô",
			alwaysChecked: false,
			isShow: true,
		},
		// {
		//     stt: 9,
		//     name: 'SOLUONGTON',
		//     displayName: 'Số lượng tồn',
		//     alwaysChecked: false,
		// 	isShow: true
		// },
		{
			stt: 9,
			name: "SOLUONG",
			displayName: "Số lượng",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 9,
			name: "MASUBLO",
			displayName: "Mã sub lô",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 9,
			name: "SOMAY",
			displayName: "Số máy",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 9,
			name: "VTKHO",
			displayName: "Vị trí kho",
			alwaysChecked: false,
			isShow: true,
		},
		{
			stt: 10,
			name: "HANSUDUNG",
			displayName: "Hạn sử dụng",
			alwaysChecked: false,
			isShow: true,
		},
	];

	columnExtend_DNXK = [
		{
			stt: 1,
			name: "SLDN",
			displayName: "SLDN",
			alwaysChecked: true,
			isShow: true,
		},
		{
			stt: 1,
			name: "SOPHIEUDNXK",
			displayName: "Số phiếu ĐNXK",
			alwaysChecked: true,
			isShow: true,
		},
		{
			stt: 1,
			name: "SOPHIEUDHB",
			displayName: "Số phiếu ĐHB",
			alwaysChecked: true,
			isShow: true,
		},
	];

	columnExtend_KHGH = [
		{
			stt: 1,
			name: "SLGIAO",
			displayName: "SL giao",
			alwaysChecked: true,
			isShow: true,
		},
		{
			stt: 1,
			name: "SOPHIEUDHB",
			displayName: "Số phiếu ĐHB",
			alwaysChecked: true,
			isShow: true,
		},
	];

	/* End comment columns mat-table -------------------------------------*/

	/* Mat select search cho nhà cung cấp */
	listListNCC: any[] = [];
	selectListNCC: string = "";
	filteredListNCC: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	ListNCCFilterCtrl: string = "";
	haveElementListNCC: boolean = false;
	/* ------------------------------------------------------------------ */

	/* Mat select search cho hop dong */
	listHD: any[] = [];
	selectHD: string = "";
	filteredHD: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	HDFilterCtrl: string = "";
	haveElementHD: boolean = false;
	/* ------------------------------------------------------------------ */

	listIdNV: any[] = [];
	selectIdNV: string = "";
	filteredIdNV: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	IdNVFilterCtrl: string = "";
	haveElementIdNV: boolean = false;

	listIdKho: any[] = [];
	selectIdKho: string = "";
	filteredIdKho: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	IdKhoFilterCtrl: string = "";
	haveElementIdKho: boolean = false;
	arrayKhoForEachHH: any[] = [];

	listIdLot: any[] = [];
	selectIdLot: string = "";
	filteredIdLot: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	IdLotFilterCtrl: string = "";
	haveElementIdLot: boolean = false;
	arrayLotForEachHH: any[] = [];

	/* Giá trị đầu tiên cho dropdown quyết định nhập hàng - Form QC kiểm tra*/
	selectQuyetDinhLoHang = "0";
	/* ------------------------------------------------------------------ */

	/* Selection */
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<KhoXuatKhoChiTiet>(true, []);
	/* ------------------------------------------------------------------ */

	/* Loading.... */
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */

	/* Extend field:  */
	previousIndex: number; // Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2; // Số chữ số phần thập phân cho kiểu dữ liệu số.
	isChange: boolean = false; // Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	isZoomSize: boolean = false; // Trường đánh dấu có đang ở trạng thái zoom size hay không
	saveAddedTTHV: number[] = []; // Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	viewLoading: boolean = false; // Loading khi mở dialog
	canEdit: boolean = false; // Dialog có thể chỉnh sửa không?
	/* ------------------------------------------------------------------ */

	/* Các Sub form trên dialog:  */
	KhoXuatKhoForm: FormGroup; //Form phiếu đề nghị
	hasFormErrors: boolean = false;

	KhoXuatKhoDuyetForm: FormGroup;

	KhoXuatKhoMoneyForm: FormGroup; //Form add hàng hóa cho phiếu
	hasMoneyFormErrors: boolean = false;

	QCKiemTraForm: FormGroup; //Form QC kiểm tra
	hasFormQCKiemTraErrors: boolean = false;
	/* ------------------------------------------------------------------ */

	/* Item dữ liệu từ của phiếu đề nghị khi mở dialog:  */
	KhoXuatKhoItem: KhoXuatKho;

	/* Danh sách chi tiết hàng hóa của phiếu đề nghị:  */
	listChiTietHangVe: KhoXuatKhoChiTiet[] = [];

	/* Danh sách tạm chi tiết hàng hóa của phiếu đề nghị dùng để cập nhập trên lưới  */
	tmpChiTietKhoXuatKho: any[] = [];

	/* Danh sách chi tiết hàng hóa của phiếu đề nghị lúc đầu dùng để so sánh -> cập nhập trạng thái phiếu */
	compareChiTietHangVe: KhoXuatKhoChiTiet[] = [];

	/* Danh sách tình trạng phiếu */

	/* Action form */
	__ACTION = 1;
	__CREATE = 1;
	__EDIT = 2;

	/* Parameter liên quan đến giá trị tiền */
	__TIENCHUATHUE = 0;
	__THUE = 0;
	__TONGTIEN = 0;

	TinhTrang = [
		{
			Code: "DDH_LUUNHAP",
			Name: "Đang soạn thảo",
		},
		{
			Code: "DDH_CHOXACNHAN",
			Name: "Chờ xác nhận",
		},
		{
			Code: "DDH_BITRALAI",
			Name: "Bị trả lại",
		},
		{
			Code: "DDH_DAHUY",
			Name: "Đã hủy",
		},
		{
			Code: "DDH_HOANTAT",
			Name: "Hoàn tất",
		},
	];

	// Loại phiếu
	__THEOYEUCAU = "KHOXK_LOAI_TYC_CODE";
	__THEOKHGH = "KHOXK_LOAI_GHKH_CODE";
	__LOAIKHAC = "KHOXKLP_XKKHAC";

	dsLoaiPhieu = [];
	dsNhanVienKho = [];

	dsKho = [];
	dsTonKho = [];
	dsLot = [];

	data_kho_list_solo = [];

	data_khotonkho_hientai = [];

	data_kho_list_solo_hhkho = [];

	data_index_disabled = 0;

	keyword = "";
	text_Button = "Chọn hàng từ phiếu đề nghị xuất kho";

	openDialog = false;
	listXuatKho: any[] = [];
	waittingExport: boolean = false;

	// .. Tag Kho =====================================================================
	listTagFull: any[] = [];
	//==============================================================================
	constructor(
		public dialogRef: MatDialogRef<KhoXuatKhoPageDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private KhoXuatKhoService:KhoXuatKhoPageService,
		private KhoDeNghiXuatKhoService: KhoDeNghiXuatKhoService,
		private DungChungService: DungChungService,
		public dialog: MatDialog,
		private KhoXuatKhoFB: FormBuilder,
		private KhoXuatKhoDuyetFB: FormBuilder,
		private QCKiemTraFB: FormBuilder,
		private router: Router,
		private datePipe: DatePipe,
		private tokenStorage: TokenStorage,
		private translate: TranslateService,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private pdfCustomService: JsPDFFontService,
		private el: ElementRef,
		private serviceKH: KDDatHangService,
		private subheaderService: SubheaderService,
		private route: ActivatedRoute,
	) { }

	/** LOAD DATA */
	ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();

		/*Get data from list when open dialog */
		this.KhoXuatKhoItem = new KhoXuatKho();
		this.KhoXuatKhoItem.clear();

		/*Load all dropdown and create form */
		this.ListLoaiPhieu();
		this.GetDSNhanVien();
		//this.LayDanhSachKho();
		//this.LayDanhSachLot();
		this.LayDanhSachTonKho();
		this.layDanhSachHangHoaTonKhoHienTai();
		this.ListTagKho();
		this.createForm();

		const id = this.data.IdXk;
		if (id && id > 0) {
			//this.viewLoading = true;
			let breadcrumbs = [
				{ title: "Kho" },
				{ title: "Xuất kho", page: "/xuat-kho" },
				{ title: "Chi tiết", page: "/xuat-kho/chi-tiet/" + id },
			];
			this.subheaderService.setBreadcrumbs(breadcrumbs);
			this.KhoXuatKhoService.detailOrder(id).subscribe((res) => {
				if (
					!res ||
					res.status == 0 ||
					res.data.TinhTrang == "KHOXK_DAXOA"
				) {
					this.back();
				} else if (res && res.status == 1) {
					this.KhoXuatKhoItem = res.data;
					var form = this.KhoXuatKhoForm.controls;
					var listColumn = ["IdHh", "QuyCach", "Dvt", "SoPhieuDHB", "SoPhieuDNXK", "IdKho", "IdCTDN", "SLDN", "IdLo", "SoMay", "Soluongthucxuat"];
					var item = this.KhoXuatKhoItem;
					if (this.KhoXuatKhoForm != null) {
						this.KhoXuatKhoItem.IdXk = id;
						form["SOPHIEU"].setValue(item.SoPhieu);
						form["NGAYLAP"].setValue(this.strDate(item.Ngaytao));
						form["NGUOILAP"].setValue(item.TenNguoiTao);
						form["DESCTINHTRANG"].setValue(item.DescTinhTrang);
						form["LOAIPHIEU"].setValue("" + item.DescLoaiPhieu);
						form["NGAYXUATKHO"].setValue(item.NgayXuat);
						form["DSNGUOITHUCHIEN"].setValue(item.TenDSNguoiThucHien.join(", "));
						form["LYDOXUAT"].setValue(item.LyDoXuat);
						form["TENTAIXE"].setValue(item.TenTaiXe);
						form["SOXE"].setValue(item.SoXe);
						form["NGUOINHANHANG"].setValue(item.NguoiNhanHang);
						form["PBNHANHANG"].setValue(item.PhongBanNhanHang);
						form["FILENAME"].setValue(item.FileChungTu);
						form["TIME_EXPORT_WAREHOUSE"].setValue(this.strDate(item.NgayXacNhanXuatKhoiVTKho));
						this.tmpChiTietKhoXuatKho = [...item.ChiTiet];
						this.tmpChiTietKhoXuatKho = this.sortListDataTMP(this.tmpChiTietKhoXuatKho, listColumn);
						this.changeDetect.detectChanges();
						//this.viewLoading = false;
					}
				}
			});
		} else {
			this.back();
		}

		this.columnExtend_DNXK.forEach((element) => {
			this.availableColumns.splice(5, 0, element);
		});
		this.selectedColumns = new SelectionModel<any>(
			true,
			this.availableColumns
		);

		/*Show column */
		this.showColumnsInTable();
		this.applySelectedColumns();
		//this.changeDetect.detectChanges();
	}

	sortListDataTMP(listTMP: any[], listColumn: string[]) {
		listTMP.sort((a, b) => {
			let step = 0;
			let sortTMP = 0;
			while (sortTMP == 0 && step < listColumn.length) {
				sortTMP = this.sortWithParams(a, b, listColumn[step]);
				step++;
			}
			return sortTMP;
		});

		// Hàm group nhóm
		// var tmpGroup = [];
		// listTMP.forEach(x => {
		// 	let indexGroup = tmpGroup.findIndex(a => a.IdHh == x.IdHh && a.SoPhieuDNXK == x.SoPhieuDNXK && a.SoPhieuDHB == x.SoPhieuDHB && a.IdKho == x.IdKho && a.IdLo == x.IdLo);
		// 	if (indexGroup > -1) {
		// 		if ((tmpGroup[indexGroup].SoMay && tmpGroup[indexGroup].SoMay == x.SoMay) || (!tmpGroup[indexGroup].SoMay && !x.SoMay))
		// 			tmpGroup[indexGroup]["Soluongthucxuat"] = Number(tmpGroup[indexGroup]["Soluongthucxuat"]) + Number(x.Soluongthucxuat);
		// 	}
		// 	else {
		// 		tmpGroup.push({ ...x });
		// 	}
		// })
		return listTMP;
	}

	sortWithParams(dataTMPA: any, dataTMPB: any, columnData: string) {
		if (!dataTMPA[columnData] || !dataTMPB[columnData]) return dataTMPA[columnData] ? 1 : (dataTMPB[columnData] ? -1 : 0)
		if (dataTMPA[columnData]) dataTMPA[columnData] = dataTMPA[columnData].toString().toUpperCase();
		if (dataTMPB[columnData]) dataTMPB[columnData] = dataTMPB[columnData].toString().toUpperCase();
		if (dataTMPA[columnData] < dataTMPB[columnData]) return -1;
		if (dataTMPA[columnData] > dataTMPB[columnData]) return 1;
		return 0;
	}

	ngAfterViewInit() {
		/*Focus on first input field*/
		//setTimeout(() => this.focusMaNCC.first.open(), 500);
		//this.changeDetect.detectChanges();
		this.changeDetect.detectChanges();
	}

	GetDSLot() {
		this.DungChungService.listLot().subscribe((res) => {
			if (res && res.status == 1) {
				this.listIdLot = res.data;
				this.filteredIdLot.next(this.listIdLot.slice());
				this.changeDetect.detectChanges();
			}
		});
	}
	filterLot() {
		if (!this.listIdLot) {
			return;
		}
		let search = this.IdLotFilterCtrl;
		if (!search) {
			this.filteredIdLot.next(this.listIdLot.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredIdLot.next(
			this.listIdLot.filter(
				(ts) => ts.TenLot.toLowerCase().indexOf(search) > -1
			)
		);
		this.changeDetect.detectChanges();
	}

	GetDSKho() {
		this.DungChungService.listKho().subscribe((res) => {
			if (res && res.status == 1) {
				this.listIdKho = res.data;
				this.filteredIdKho.next(this.listIdKho.slice());
				this.changeDetect.detectChanges();
			}
		});
	}
	filterKho(item: any) {
		if (!this.listIdKho) {
			return;
		}
		let search = this.IdKhoFilterCtrl;
		let index = this.tmpChiTietKhoXuatKho.indexOf(item);
	}

	GetDSNhanVien() {
		let cocau = "";
		this.tokenStorage.getCoCauId().subscribe((r) => (cocau = r));
		this.DungChungService.listNVPB(+cocau).subscribe((res) => {
			if (res && res.status == 1) {
				this.listIdNV = res.data;
				this.filteredIdNV.next(this.listIdNV.slice());
				this.changeDetect.detectChanges();
			}
		});
	}

	filterNhanVien() {
		if (!this.listIdNV) {
			return;
		}
		let search = this.IdNVFilterCtrl;
		if (!search) {
			this.filteredIdNV.next(this.listIdNV.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredIdNV.next(
			this.listIdNV.filter(
				(ts) => ts.TenNV.toLowerCase().indexOf(search) > -1
			)
		);
		this.changeDetect.detectChanges();
	}

	ListLoaiPhieu() {
		this.DungChungService.listStatus("KHOXKLP").subscribe((res) => {
			if (res && res.status == 1) {
				this.dsLoaiPhieu = res.data;
			}
			this.changeDetect.detectChanges();
		});
	}

	/*Create Form with appropriate sub forms */
	createForm() {
		/*Get name of người lập phiếu */
		var tenNguoiLap = "";
		this.tokenStorage.getFullName().subscribe((t) => {
			tenNguoiLap = t;
		});

		/*Group các Form */
		this.KhoXuatKhoForm = this.KhoXuatKhoFB.group({
			SOPHIEU: [
				!(
					this.KhoXuatKhoItem.SoPhieu == undefined ||
					this.KhoXuatKhoItem.SoPhieu == ""
				)
					? this.KhoXuatKhoItem.SoPhieu
					: this.createBillNumber(),
				Validators.required,
			],
			NGAYLAP: [
				!(
					this.KhoXuatKhoItem.Ngaytao == undefined ||
					this.KhoXuatKhoItem.Ngaytao == ""
				)
					? this.KhoXuatKhoItem.Ngaytao
					: new Date(),
				Validators.required,
			],
			NGUOILAP: [
				this.KhoXuatKhoItem.IdXk > 0
					? this.KhoXuatKhoItem.TenNguoiTao
					: tenNguoiLap,
			],
			TINHTRANG: [
				this.KhoXuatKhoItem.TinhTrang == ""
					? this.TinhTrang[0].Code
					: this.KhoXuatKhoItem.TinhTrang,
			],
			DESCTINHTRANG: [
				this.KhoXuatKhoItem.TinhTrang == ""
					? this.TinhTrang[0].Name
					: this.KhoXuatKhoItem.DescTinhTrang,
			],
			NGAYXUATKHO: [
				!(
					this.KhoXuatKhoItem.NgayXuat == undefined ||
					this.KhoXuatKhoItem.NgayXuat == ""
				)
					? this.KhoXuatKhoItem.NgayXuat
					: new Date(),
				Validators.required,
			],
			LOAIPHIEU: [
				this.KhoXuatKhoItem.LoaiPhieu == 0
					? ""
					: this.KhoXuatKhoItem.DescLoaiPhieu,
			],
			DSNGUOITHUCHIEN: [
				this.KhoXuatKhoItem.DSNguoiThucHien.length == 0
					? ""
					: this.KhoXuatKhoItem.TenDSNguoiThucHien.join(", "),
			],
			LYDOXUAT: [
				this.KhoXuatKhoItem.LyDoXuat == "" ||
					this.KhoXuatKhoItem.LyDoXuat == null ||
					this.KhoXuatKhoItem.LyDoXuat == undefined
					? ""
					: this.KhoXuatKhoItem.LyDoXuat,
				Validators.required,
			],
			TENTAIXE: [
				""
			],
			SOXE: [
				""
			],
			NGUOINHANHANG: [
				""
			],
			PBNHANHANG: [
				""
			],
			FILENAME: [""],
			TIME_EXPORT_WAREHOUSE : ['']
			//XUATHANGDIXULY: [this.KhoXuatKhoItem.XuatHangDiXuLy],
		});

		this.KhoXuatKhoDuyetForm = this.KhoXuatKhoDuyetFB.group({
			NGUOIXACNHAN: [
				this.KhoXuatKhoItem.TenNguoixacnhan == undefined ||
					this.KhoXuatKhoItem.TenNguoixacnhan == "" ||
					this.KhoXuatKhoItem.TenNguoixacnhan == null
					? ""
					: this.KhoXuatKhoItem.TenNguoixacnhan,
				Validators.required,
			],
			NGAYXACNHAN: [
				!(
					this.KhoXuatKhoItem.Ngayxacnhan == undefined ||
					this.KhoXuatKhoItem.Ngayxacnhan == ""
				)
					? this.KhoXuatKhoItem.Ngayxacnhan
					: "",
				Validators.required,
			],
			LYDO: [
				this.KhoXuatKhoItem.LyDo == "" ||
					this.KhoXuatKhoItem.LyDo == undefined ||
					this.KhoXuatKhoItem.LyDo == null
					? ""
					: this.KhoXuatKhoItem.LyDo,
			],
		});

		/*Disable các trường dữ liệu không thay đổi */
		this.KhoXuatKhoForm.controls["SOPHIEU"].disable();
		this.KhoXuatKhoForm.controls["NGUOILAP"].disable();
		this.KhoXuatKhoForm.controls["NGAYLAP"].disable();
		this.KhoXuatKhoForm.controls["DESCTINHTRANG"].disable();
		this.KhoXuatKhoForm.controls["LOAIPHIEU"].disable();
		this.KhoXuatKhoForm.controls["DSNGUOITHUCHIEN"].disable();
		this.KhoXuatKhoForm.controls["NGAYXUATKHO"].disable();
		this.KhoXuatKhoForm.controls["LYDOXUAT"].disable();

		this.KhoXuatKhoForm.controls["TENTAIXE"].disable();
		this.KhoXuatKhoForm.controls["SOXE"].disable();
		this.KhoXuatKhoForm.controls["NGUOINHANHANG"].disable();
		this.KhoXuatKhoForm.controls["PBNHANHANG"].disable();
		this.KhoXuatKhoForm.controls["FILENAME"].disable();
		//this.KhoXuatKhoForm.controls["XUATHANGDIXULY"].disable();

		this.KhoXuatKhoDuyetForm.controls["NGUOIXACNHAN"].disable();
		this.KhoXuatKhoDuyetForm.controls["NGAYXACNHAN"].disable();
		this.KhoXuatKhoDuyetForm.controls["LYDO"].disable();
		this.KhoXuatKhoDuyetForm.controls["NGUOIXACNHAN"].disable();
		this.KhoXuatKhoDuyetForm.disable();

		this.tmpChiTietKhoXuatKho = this.KhoXuatKhoItem.ChiTiet;
		this.tmpChiTietKhoXuatKho = [...this.tmpChiTietKhoXuatKho];
	}

	/*Lấy tiêu đề cho dialog với các TH thêm - sửa - QC kiểm tra*/
	getTitle(): string {
		if (this.KhoXuatKhoItem.IdXk == 0) {
			return "THÊM MỚI PHIẾU XUẤT KHO";
		}
		return `CHI TIẾT PHIẾU XUẤT KHO `;
	}

	getSoPhieu() {
		return this.KhoXuatKhoItem.SoPhieu;
	}

	/*Xóa dữ liệu hàng hóa trong bảng*/
	deleteItem(item: any) {
		let index = this.tmpChiTietKhoXuatKho.indexOf(item, 0);
		if (index > -1) {
			this.tmpChiTietKhoXuatKho.splice(index, 1);
		}
		this.tmpChiTietKhoXuatKho = [...this.tmpChiTietKhoXuatKho];
	}

	/*Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng*/
	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column) return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(
				this.availableColumns,
				this.previousIndex,
				this.findIndexColumn(column)
			);
			this.applySelectedColumns();
		}
	}

	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(
			true,
			this.availableColumns
		);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];

		this.selectedColumns.selected.forEach((col) => {
			_applySelectedColumns.push(col.name);
		});

		this.displayedColumns = _applySelectedColumns;
	}
	/*---------------------------------------------------------------------------------------- */

	/*Hàm thông báo lỗi cho form tương ứng */
	onAlertSubFormClose($event) {
		this.hasMoneyFormErrors = false;
	}
	onAlertFormClose($event) {
		this.hasFormErrors = false;
	}
	onAlertFormQCKiemTraClose($event) {
		this.hasFormQCKiemTraErrors = false;
	}
	/*---------------------------------------- */

	formatComparenumber(number: string) {
		return +number.replace(/,/g, "");
	}

	/*Các hàm hỗ trợ cho mat select search Nhà cung cấp*/
	ListNCC() {
		this.DungChungService.listNCC().subscribe((res) => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listListNCC = res.data;
				this.filteredListNCC.next(this.listListNCC.slice());
				this.changeDetect.detectChanges();
			}
		});
	}
	filterListNCC() {
		if (!this.listListNCC) {
			return;
		}
		// get the search keyword
		let search = this.ListNCCFilterCtrl;
		if (!search) {
			this.filteredListNCC.next(this.listListNCC.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredListNCC.next(
			this.listListNCC.filter(
				(ts) => ts.TenNCC.toLowerCase().indexOf(search) > -1
			)
		);
		this.changeDetect.detectChanges();
	}
	/*------------------------------------------ */

	/*Hàm hỗ trợ format các dạng số trên form*/
	changeValueOfForm(controlName: string, event: any) {
		if (this.ValidateChangeNumberForm(event)) {
			let tmpValue = this.KhoXuatKhoMoneyForm.controls[
				controlName
			].value.replace(/,/g, "");
			this.KhoXuatKhoMoneyForm.controls[controlName].setValue(
				this.f_currency(this.formatNumber(tmpValue))
			);
		} else {
			this.KhoXuatKhoMoneyForm.controls[controlName].setValue(
				event.target.value
			);
		}
	}
	ValidateChangeNumberForm(event: any, isEvent: boolean = true) {
		var count = 0;
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == ".") {
					count += 1;
				}
			}
		} else {
			event = "" + event;
			for (let i = 0; i < event.length; i++) {
				if (event[i] == ".") {
					count += 1;
				}
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = isEvent
			? event.target.value.match(regex)
			: event.match(regex);
		if (found != null) {
			const message = "Số lượng không gồm chữ hoặc kí tự đặc biệt";
			this.layoutUtilsService.showErorr(message);
			return false;
		}
		if (count >= 2) {
			const message = "Số lượng không thể có nhiều hơn 2 dấu .";
			this.layoutUtilsService.showErorr(message);
			return false;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == "" || item == null || item == undefined) return "";
		return Number(
			Math.round(parseFloat(item + "e" + this.fixedPoint)) +
			"e-" +
			this.fixedPoint
		).toFixed(this.fixedPoint);
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == "") value = "0.00";
		let nbr = Number(
			(
				value.substring(0, value.length - (this.fixedPoint + 1)) + ""
			).replace(/,/g, "")
		);
		return (
			(nbr + "").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") +
			value.substr(
				value.length - (this.fixedPoint + 1),
				this.fixedPoint + 1
			)
		);
	}
	f_currency_V2(value: string): any {
		if (value == "-1") return "";
		if (value == null || value == undefined || value == "") value = "0";
		let nbr = Number((value + "").replace(/,/g, ""));
		return (nbr + "").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	/*------------------------------------------------------------- */

	/*Hàm hỗ trợ format các dạng ngày trên form*/
	getFormatDate(v: string = "") {
		if (v != "") {
			return v.includes("T")
				? v.replace(
					/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g,
					"$5/$3/$1"
				)
				: v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return "";
	}
	f_convertDate(p_Val: any) {
		if (p_Val == null || p_Val == undefined || p_Val == "") return "";
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return (
			("0" + a.getDate()).slice(-2) +
			"/" +
			("0" + (a.getMonth() + 1)).slice(-2) +
			"/" +
			a.getFullYear()
		);
	}
	/*------------------------------------------------------------- */

	/* Tạo số phiếu tự động */
	createBillNumber() {
		let d = new Date();
		return "DH" + d.getTime();
	}

	/* Chọn Mã NCC */

	/* Kiểm tra gửi duyệt */
	checkGuiDuyet(checked: boolean = false) {
		if (checked) {
			this.KhoXuatKhoForm.controls["DESCTINHTRANG"].setValue(
				this.TinhTrang[1].Name
			);
			this.KhoXuatKhoForm.controls["TINHTRANG"].setValue(
				this.TinhTrang[1].Code
			);
		} else {
			this.KhoXuatKhoForm.controls["DESCTINHTRANG"].setValue(
				this.TinhTrang[0].Name
			);
			this.KhoXuatKhoForm.controls["TINHTRANG"].setValue(
				this.TinhTrang[0].Code
			);
		}
	}

	/* Mở danh sách phiếu đề nghị */
	openDialogDeNghi() {
		let list = [];
		this.tmpChiTietKhoXuatKho.forEach((x) => {
			if (
				list.findIndex(
					(a) => a.IdHh == x.IdHh && a.IdCTDN == x.IdCTDN
				) == -1
			) {
				list.push(x);
			}
		});
		const dialogRef = this.dialog.open(KhoXuatKhoPageDSDNComponent, {
			data: {
				list: list,
			},
			maxHeight: "90vh",
			width: "90vw",
		});
		dialogRef.afterClosed().subscribe((res) => {
			if (res == undefined || res == null) {
				return;
			} else {
				if (res.list.length != 0 && res.action) {
					this.tmpChiTietKhoXuatKho = [];
					//this.tmpChiTietKhoXuatKho = res.list;
					let tmpArr = [];

					for (let i = 0; i < res.list.length; i++) {
						let element = res.list[i];
						let record = 0;
						let soluongdenghi = element.Soluongdn;
						let dsLot = this.setListLotHHKhongTheoKho(element.IdHh);

						for (let lt = 0; lt < dsLot.length; lt++) {
							if (soluongdenghi <= 0) break;
							let elementLo = dsLot[lt];
							let _idKhoOfLot = this.getKhoTuSoLo(
								element.IdHh,
								elementLo.Id_Lot
							);
							for (let k = 0; k < _idKhoOfLot.length; k++) {
								if (soluongdenghi <= 0) break;
								let SLTon = 0;
								this.dsTonKho.forEach((t) => {
									if (
										t.Trang_Thai == 1 &&
										t.Id_HH == +element.IdHh &&
										t.Id_Kho == _idKhoOfLot[k].Id_Kho &&
										t.Id_Lo == +elementLo.Id_Lot
									) {
										SLTon += t.So_Luong;
									}
								});
								let tmp = element;
								let sl =
									soluongdenghi > SLTon
										? SLTon
										: soluongdenghi;
								soluongdenghi -= SLTon;
								let create = this.createElementCT(
									element,
									sl,
									this.setListKhoHH(tmp.IdHh),
									this.setListLotHH(
										tmp.IdHh,
										_idKhoOfLot[k].Id_Kho
									),
									_idKhoOfLot[k].Id_Kho,
									elementLo.Id_Lot
								);
								tmpArr.push(create);
							}
						}
						if (soluongdenghi > 0) {
							let create = this.createElementCT(
								element,
								soluongdenghi,
								this.setListKhoHH(element.IdHh),
								[],
								0,
								0
							);
							tmpArr.push(create);
						}
					}

					tmpArr.sort(function (a, b) {
						return a.Id_Kho - b.Id_Kho;
					});
					this.tmpChiTietKhoXuatKho = [];
					this.tmpChiTietKhoXuatKho = [...tmpArr];
					this.changeDetect.detectChanges();
				}
			}
		});
	}

	createElementCT(
		x: KhoXuatKhoChiTiet,
		soluong: number,
		listKho: any[],
		listSoLo: any[],
		idKho: number,
		idSoLo: number
	) {
		let item = new KhoXuatKhoChiTiet();
		item.IdHh = x.IdHh;
		item.TenHH = x.TenHH;
		item.MaHH = x.MaHH;
		item.Dvt = x.Dvt;
		item.TenDvt = x.TenDvt;
		item.Soluongdn = x.Soluongdn;
		item.QuyCach = x.QuyCach;
		item.Soluongthucnhan = 0;
		item.Ghichu = x.Ghichu;
		item.ListKho = listKho;
		item.ListSoLo = listSoLo;
		item.IdKho = idKho;
		item.IdLo = idSoLo;
		item.Soluongthucxuat = soluong;
		item.IdCTDN = x.IdCTDN;
		this.updateSLTon(item, item.IdHh, item.IdKho, item.IdLo);
		if (item.IdLo > 0) item.HanSuDung = this.getHSDLot(item.IdLo);
		return item;
	}

	createRecordKho(soluongdenghi: number, element: any) {
		if (soluongdenghi <= 0) return;
		for (let xKho = 0; xKho < element.ListKho; xKho++) {
			if (soluongdenghi <= 0) break;

			let elementKho = element.ListKho[xKho];
			element.IdKho = elementKho.Id_Kho;
			element.ListSoLo = this.setListLotHH(+element.IdHh, +element.IdKho);
			this.createRecordSoLo(soluongdenghi, element);
		}
	}

	createRecordSoLo(soluongdenghi: number, element: any) {
		if (soluongdenghi <= 0) return;
		for (let xLo = 0; xLo < element.ListSoLo.length; xLo++) {
			if (soluongdenghi <= 0) break;

			let elementLo = element.ListSoLo[xLo];
			let SLTon = 0;
			this.dsTonKho.forEach((t) => {
				if (
					t.Trang_Thai == 1 &&
					t.Id_HH == +element.IdHh &&
					t.Id_Kho == +element.IdKho &&
					t.Id_Lo == +element.IdLot
				) {
					SLTon += t.So_Luong;
				}
			});
			if (soluongdenghi <= SLTon) {
				soluongdenghi = 0;
				element.Soluongthucxuat = soluongdenghi;
			} else {
				element.Soluongthucxuat = SLTon;
				soluongdenghi -= SLTon;

				this.tmpChiTietKhoXuatKho.push(element);
			}
		}
	}

	back() {
		this.dialogRef.close({});
	}
	onSubmit(action: number = 0) {
		this.hasFormErrors = false;
		const controls = this.KhoXuatKhoForm.controls;
		/** check form */
		if (this.KhoXuatKhoForm.invalid) {
			const invalidElements = this.el.nativeElement.querySelectorAll(
				".ng-invalid"
			);
			//let indexList = [];
			if (invalidElements.length > 0) {
				for (let i = 0; i < invalidElements.length; i++) {
					if (
						invalidElements[i].nodeName == "INPUT" ||
						invalidElements[i].nodeName == "MAT-SELECT"
					) {
						const elementControl = this.KhoXuatKhoForm.get(
							invalidElements[i].attributes.getNamedItem(
								"formcontrolname"
							).value
						);
						if (elementControl) {
							setTimeout(() => invalidElements[i].focus(), 100);
							break;
						}
					}
				}
			}

			Object.keys(controls).forEach((controlName) =>
				controls[controlName].markAsTouched()
			);
			this.hasFormErrors = true;
			return;
		}

		if (this.tmpChiTietKhoXuatKho.length == 0) {
			const message =
				"Vui lòng thêm ít nhất một hàng hóa vào đơn đặt hàng.";
			this.layoutUtilsService.showErorr(message);
			return false;
		}

		let __exist = false;

		const _result = new KhoXuatKho();
		_result.clear();
		_result.SoPhieu = this.KhoXuatKhoForm.controls["SOPHIEU"].value;
		_result.TinhTrang = action == 0 ? "KHOXK_PHIEUMOI" : "KHOXK_HOANTAT";
		_result.ChiTiet = this.tmpChiTietKhoXuatKho;
		_result.LoaiPhieu = this.KhoXuatKhoForm.controls["LOAIPHIEU"].value;
		_result.DSNguoiThucHien =
			this.KhoXuatKhoForm.controls["DSNGUOITHUCHIEN"].value.length > 0
				? this.KhoXuatKhoForm.controls[
					"DSNGUOITHUCHIEN"
				].value.map((i) => Number(i))
				: [];

		if (this.KhoXuatKhoItem.IdXk > 0) {
			_result.IdXk = this.KhoXuatKhoItem.IdXk;
			this.updateKhoXuatKho(_result, action);
			return;
		}
		this.addKhoXuatKho(_result, action);
	}

	updateKhoXuatKho(item: KhoXuatKho, withBack: number = 0) {
		this.KhoXuatKhoService.editOrder(item).subscribe((res) => {
			if (res && res.status == 1) {
				this.isChange = true;
				const message = `Cập nhật phiếu xuất kho thành công.`;
				this.layoutUtilsService.showInfo(message);

				// Cập nhật lại khi đã thêm
				this.KhoXuatKhoItem = res.data;
				this.isChange = true;
				this.saveAddedTTHV = [];
				this.saveAddedTTHV.push(res.data.IdDn);
				this.changeDetect.detectChanges();

				// Lưu nháp
				if (withBack == 0) return;
				this.checkGuiDuyet(true);

				// Lưu và thêm mới
				if (withBack == 2) {
					this.tmpChiTietKhoXuatKho = [];
					this.tmpChiTietKhoXuatKho = [...this.tmpChiTietKhoXuatKho];
					this.changeDetect.detectChanges();
					return;
				}
				// Lưu và trờ lại
				if (withBack == 1) {
					this.KhoXuatKhoForm.reset();
					this.tmpChiTietKhoXuatKho = [];
					this.tmpChiTietKhoXuatKho = [...this.tmpChiTietKhoXuatKho];
					this.back();
				}
			} else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}

	addKhoXuatKho(item: KhoXuatKho, withBack: number = 0) {
		this.KhoXuatKhoService.insertOrder(item).subscribe((res) => {
			if (res && res.status == 1) {
				const message = `Thêm phiếu xuất kho thành công.`;
				this.layoutUtilsService.showInfo(message);

				// Cập nhật lại khi đã thêm
				this.KhoXuatKhoItem = res.data;
				this.isChange = true;
				this.saveAddedTTHV = [];
				this.saveAddedTTHV.push(res.data.IdDn);
				this.changeDetect.detectChanges();

				// Lưu nháp
				if (withBack == 0) return;
				this.checkGuiDuyet(true);

				// Lưu và thêm mới
				if (withBack == 2) {
					this.tmpChiTietKhoXuatKho = [];
					this.tmpChiTietKhoXuatKho = [...this.tmpChiTietKhoXuatKho];
					this.changeDetect.detectChanges();
					return;
				}
				// Lưu và trờ lại
				if (withBack == 1) {
					this.KhoXuatKhoForm.reset();
					this.tmpChiTietKhoXuatKho = [];
					this.tmpChiTietKhoXuatKho = [...this.tmpChiTietKhoXuatKho];
					this.back();
				}
			} else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}

	isChecked() {
		if (
			this.KhoXuatKhoItem.TinhTrang == this.TinhTrang[1].Code ||
			this.KhoXuatKhoItem.TinhTrang == this.TinhTrang[3].Code
		) {
			return true;
		}
		return false;
	}
	validateInvalidForm(isAddDetail: boolean = false) {
		this.hasFormErrors = false;
		const controls = this.KhoXuatKhoForm.controls;
		if (this.KhoXuatKhoForm.invalid) {
			const invalidElements = this.el.nativeElement.querySelectorAll(
				".ng-invalid"
			);
			if (invalidElements.length > 0) {
				for (let i = 0; i < invalidElements.length; i++) {
					if (
						invalidElements[i].nodeName == "INPUT" ||
						invalidElements[i].nodeName == "MAT-SELECT"
					) {
						const elementControl = this.KhoXuatKhoForm.get(
							invalidElements[i].attributes.getNamedItem(
								"formcontrolname"
							).value
						);
						if (elementControl) {
							setTimeout(() => invalidElements[i].focus(), 100);
							break;
						}
					}
				}
			}
			Object.keys(controls).forEach((controlName) =>
				controls[controlName].markAsTouched()
			);
			this.hasFormErrors = false;
			return false;
		}

		if (!isAddDetail) {
			this.forcusAnotherEmptyField(controls);
		}
		return true;
	}
	closeDropdownEvent(dropdownName: string) {
		if (dropdownName == "MaNCC") {
			setTimeout(() => this.focusMaNCC.first.close(), 0);
			this.changeDetect.detectChanges();
		}

		this.hasFormErrors = false;
		this.validateInvalidForm();
		this.changeDetect.detectChanges();
	}

	forcusAnotherEmptyField(control: any) {
		let run: boolean = true;
		Object.keys(control).forEach((controlName) => {
			if (
				(control[controlName].value == null ||
					control[controlName].value == undefined ||
					control[controlName].value == "") &&
				run
			) {
				if (controlName == "DKTHANHTOAN") {
					setTimeout(
						() => this.focusDKThanhToan.first.nativeElement.focus(),
						0
					);
					run = false;
					this.changeDetect.detectChanges();
				}
				if (controlName == "DIENGIAI") {
					setTimeout(
						() => this.focusDienGiai.first.nativeElement.focus(),
						0
					);
					run = false;
					this.changeDetect.detectChanges();
				}
			}
		});
	}

	clearSelectNCC(event: any) {
		this.selectListNCC = "";
		this.KhoXuatKhoForm.controls["MANCC"].setValue("");
		this.KhoXuatKhoForm.controls["TENNCC"].setValue("");
		this.KhoXuatKhoForm.controls["NGUOILIENHE"].setValue("");
		this.KhoXuatKhoForm.controls["SDTNGUOILIENHE"].setValue("");
		this.KhoXuatKhoForm.controls["DIACHI"].setValue("");

		event.stopPropagation();
		setTimeout(() => this.focusMaNCC.first.open(), 500);
		this.changeDetect.detectChanges();
	}

	//Dropdown tren luoi

	async LayDanhSachKho() {
		let res = await this.DungChungService.listKho().toPromise();
		if (res && res.status == 1) {
			this.dsKho = res.data;
			this.filteredIdKho.next(res.data);
			this.LayDanhSachLot();
		} else {
			this.layoutUtilsService.showErorr(res.error.message);
		}
	}

	async LayDanhSachTonKho() {
		let res = await this.DungChungService.listTonKho().toPromise();
		if (res && res.status == 1) {
			this.dsTonKho = res.data;
			this.LayDanhSachKho();
		} else {
			this.layoutUtilsService.showErorr(res.error.message);
		}
	}

	LayDanhSachLot() {
		this.DungChungService.listLot().subscribe((res) => {
			if (res && res.status == 1) {
				this.dsLot = res.data;
				if (this.KhoXuatKhoItem.IdXk > 0) {
					this.tmpChiTietKhoXuatKho.forEach((x) => {
						x.ListKho = this.setListKhoHH(x.IdHh);
						x.ListSoLo = this.setListLotHH(x.IdHh, x.IdKho, true);
						//x.ListVTKho =  this.setListVTHH(x.IdHh, x.IdKho, x.IdLo)
					});
					let tmp = this.tmpChiTietKhoXuatKho;
					this.tmpChiTietKhoXuatKho = [...tmp];
					this.changeDetect.detectChanges();
				}
			}
		});
	}

	// Ham ho tro dropdown tren luoi

	setListKhoHH(IdHH: number) {
		if (IdHH == 0) return [];
		let khoInTonKho = [];
		let khoOfHH = [];
		// Tim tat ca kho cua hang hoa
		this.dsTonKho.forEach((tk) => {
			if (
				tk.Trang_Thai == 1 &&
				tk.Id_HH == IdHH &&
				khoInTonKho.findIndex((x) => x == tk.Id_Kho) == -1
			)
				khoInTonKho.push(tk.Id_Kho);
		});
		// Lay thong tin kho da tim dc
		khoInTonKho.forEach((k) => {
			let index = this.dsKho.findIndex((x) => x.Id_Kho == k);
			if (index > -1) khoOfHH.push(this.dsKho[index]);
		});
		khoOfHH.sort(function (a, b) {
			return a.Id_Kho - b.Id_Kho;
		});
		return khoOfHH;
	}

	getKhoTuSoLo(IdHH: number, IdLo: number) {
		if (IdLo == 0 || IdHH == 0) return [];
		let dsKhoTheoSoLo = [];
		let khoChuaLot = [];

		this.dsTonKho.sort(function (a, b) {
			return a.So_Luong - b.So_Luong;
		});

		this.dsTonKho.forEach((tk) => {
			if (
				tk.Trang_Thai == 1 &&
				tk.Id_Lo == IdLo &&
				tk.Id_HH == IdHH &&
				dsKhoTheoSoLo.findIndex((x) => x == tk.Id_Kho) == -1
			)
				dsKhoTheoSoLo.push(tk.Id_Kho);
		});
		dsKhoTheoSoLo.forEach((k) => {
			let index = this.dsKho.findIndex((x) => x.Id_Kho == k);
			if (index > -1) khoChuaLot.push(this.dsKho[index]);
		});

		return khoChuaLot;
	}

	setListLotHHKhongTheoKho(IdHH: number) {
		if (IdHH == 0) return [];
		let lotInTonKho = [];
		let lotOfHH = [];
		this.dsTonKho.forEach((tk) => {
			if (
				tk.Trang_Thai == 1 &&
				tk.Id_HH == IdHH &&
				lotInTonKho.findIndex((x) => x == tk.Id_Lo) == -1
			)
				lotInTonKho.push(tk.Id_Lo);
		});
		lotInTonKho.forEach((k) => {
			let index = this.dsLot.findIndex((x) => x.Id_Lot == k);
			if (index > -1) lotOfHH.push(this.dsLot[index]);
		});
		lotOfHH.sort(function (a, b) {
			let timeA = new Date(a.HSD);
			let timeB = new Date(b.HSD);
			return timeA.getTime() - timeB.getTime();
		});
		return lotOfHH;
	}

	setListLotHH(
		IdHH: number,
		IdKho: number,
		isLoadKhiLuuTam: boolean = false
	) {
		if (IdHH == 0 || IdKho == 0) return [];
		let lotInTonKho = [];

		this.data_khotonkho_hientai.forEach((tk) => {
			if (tk.Id_HH == IdHH) {
				tk.Kho.forEach((k) => {
					if (k.Id_Kho == IdKho) {
						let Lot = k.Lot;
						Lot.forEach((l) => {
							let ListVTK = l.ListVTK;
							ListVTK.forEach((v) => {
								if (
									!this.checkSoLoTrongList(
										tk.Id_HH,
										k.Id_Kho,
										l.Id_Lot,
										v.VTK,
										this.laySoLuongSoLoTu_DataKhoListSolo(
											tk.Id_HH,
											k.Id_Kho,
											l.Id_Lot,
											v.VTK
										)
									) ||
									isLoadKhiLuuTam
								) {
									lotInTonKho.push({
										Id_HH: tk.Id_HH,
										Id_Kho: k.Id_Kho,
										Id_Lot: l.Id_Lot,
										SoLo: l.SoLo,
										HSD: l.HSD,
										DVT: l.DVT,
										Date: v.Date,
										ChoPhepXuatKhoUuTien:
											l.ChoPhepXuatKhoUuTien,
										VTK: v.VTK,
										SLTon: v.SLTon,
										Disabled: v.Disabled,
										Id_TonKhoHienTai: v.Id_TonKhoHienTai,
										NgayNhapKho: v.NgayNhapKho,
									});
								}
							});
						});
					}
				});
			}
		});

		var newlotOfHH = [];
		// Số lượng tồn thực hiển thị
		lotInTonKho.forEach((x) => {
			let soluongton_temp =
				this.laySoLuongSoLoTu_DataKhoListSolo(
					IdHH,
					IdKho,
					x.Id_Lot,
					x.VTK,
					true
				) - this.laySoLuongSoLoTu_ListTam(IdHH, IdKho, x.Id_Lot, x.VTK);
			x.SLTon = soluongton_temp > 0 ? soluongton_temp : 0;
			if (x.SLTon > 0 || isLoadKhiLuuTam) newlotOfHH.push(x);
		});

		if (newlotOfHH.length > 0) {
			newlotOfHH.forEach((x) => {
				if (x.ChoPhepXuatKhoUuTien || newlotOfHH.indexOf(x) == 0)
					x.Disabled = false;
			});
		}

		return newlotOfHH;
	}

	laySoLuongSoLoTu_ListTam(
		idhh: number,
		idkho: number,
		idlot: number,
		VTK: string
	) {
		let index = this.tmpChiTietKhoXuatKho.findIndex(
			(x) =>
				x.IdHh == idhh &&
				x.IdKho == idkho &&
				x.IdLo == idlot &&
				x.ViTriKho == VTK
		);
		if (index > -1) return this.tmpChiTietKhoXuatKho[index].Soluongthucxuat;
		return 0;
	}

	checkSoLoTrongList(
		idhh: number,
		idkho: number,
		idlot: number,
		vtk: string,
		soluong: number
	) {
		return (
			this.tmpChiTietKhoXuatKho.findIndex(
				(x) =>
					x.IdHh == idhh &&
					x.IdKho == idkho &&
					x.IdLo == idlot &&
					x.Soluongthucxuat == soluong &&
					x.ViTriKho == vtk
			) > -1
		);
	}

	updateSLTon(
		item: KhoXuatKhoChiTiet,
		IdHH: number = 0,
		IdKho: number = 0,
		IdLot: number = 0
	) {
		if (IdHH == 0) return 0;
		let SLTon = 0;
		if (IdHH > 0) {
			this.dsTonKho.forEach((t) => {
				if (t.Trang_Thai == 1 && t.Id_HH == IdHH) {
					SLTon += t.So_Luong;
				}
			});
		}
		if (+IdKho > 0) {
			SLTon = 0;
			this.dsTonKho.forEach((t) => {
				if (
					t.Trang_Thai == 1 &&
					t.Id_HH == IdHH &&
					t.Id_Kho == +IdKho
				) {
					SLTon += t.So_Luong;
				}
			});
		}
		if (+IdLot > 0) {
			SLTon = 0;
			this.dsTonKho.forEach((t) => {
				if (
					t.Trang_Thai == 1 &&
					t.Id_HH == IdHH &&
					t.Id_Kho == +IdKho &&
					t.Id_Lo == +IdLot
				) {
					SLTon += t.So_Luong;
				}
			});
		}
		item.Soluongthucnhan = SLTon;
	}

	serachListKho(item: KhoXuatKhoChiTiet, arr: any[]) {
		// get the search keyword
		let search = this.keyword;
		if (!search) {
			item.ListKho = this.setListKhoHH(item.IdHh);
			return;
		} else {
			search = search.toLowerCase();
		}
		item.ListKho = this.setListKhoHH(item.IdHh).filter(
			(ts) => ts.TenKho.toLowerCase().indexOf(search) > -1
		);
		this.changeDetect.detectChanges();
	}

	serachListLot(item: KhoXuatKhoChiTiet, arr: any[]) {
		// get the search keyword
		let search = this.keyword;
		if (!search) {
			item.ListSoLo = this.setListLotHH(item.IdHh, item.IdKho);
			return;
		} else {
			search = search.toLowerCase();
		}
		item.ListSoLo = this.setListLotHH(item.IdHh, item.IdKho).filter(
			(ts) => ts.Ten_Lot.toLowerCase().indexOf(search) > -1
		);
		this.changeDetect.detectChanges();
	}

	updateItemKho(item: KhoXuatKhoChiTiet, IdKho: any) {
		item.IdKho = +IdKho;
		item.ListSoLo = this.setListLotHH(item.IdHh, item.IdKho);
		for (let a = 0; a < item.ListSoLo.length; a++) {
			if (
				!this.kiemTraDaChonChuaLot(
					item,
					item.IdKho,
					item.ListSoLo[a].Id_Lot
				)
			) {
				this.updateItemLot(item, item.ListSoLo[a].Id_Lot);
			}
		}
		this.changeDetect.detectChanges();
	}

	updateItemLot(item: KhoXuatKhoChiTiet, IdLot: any) {
		item.IdLo = +IdLot;
		item.HanSuDung = this.getHSDLot(+IdLot);
		this.changeDetect.detectChanges();
	}

	getHSDLot(IdLot: number) {
		let index = this.dsLot.findIndex((x) => x.Id_Lot == IdLot);
		if (index > -1) return this.dsLot[index].HSD;
	}

	changeValueOfColumn(
		columnName: string,
		item: any,
		event: any,
		afterUpdate: boolean
	) {
		if (columnName == "GHICHU") {
			if (afterUpdate)
				this.tmpChiTietKhoXuatKho[
					this.tmpChiTietKhoXuatKho.indexOf(item)
				].GhiChu = item.GhiChu;
			else if (!afterUpdate) {
				this.tmpChiTietKhoXuatKho[
					this.tmpChiTietKhoXuatKho.indexOf(item)
				].GhiChu = event.target.value.trim();
			}
		}
		if (columnName == "SOLUONG") {
			if (afterUpdate)
				this.tmpChiTietKhoXuatKho[
					this.tmpChiTietKhoXuatKho.indexOf(item)
				].Soluongthucxuat = this.formatNumber(item.Soluongthucxuat);
			else if (!afterUpdate) {
				let slton = this.tmpChiTietKhoXuatKho[
					this.tmpChiTietKhoXuatKho.indexOf(item)
				].Soluongthucnhan;
				if (
					+event.target.value.trim() <= item &&
					this.ValidateChangeNumberEvent(columnName, item, event)
				) {
					this.tmpChiTietKhoXuatKho[
						this.tmpChiTietKhoXuatKho.indexOf(item)
					].Soluongthucxuat = event.target.value.trim();
				} else {
					let tmp = this.tmpChiTietKhoXuatKho;
					this.tmpChiTietKhoXuatKho = [...tmp];
					this.changeDetect.detectChanges();
				}
			}
		}
	}

	DuaVeGiaTriBanDau(columnName: string, item: any, event: any) {
		if (!this.ValidateChangeNumberEvent(columnName, item, event)) {
			event.preventDefault();
		}
	}

	ValidateChangeNumberEvent(columnName: string, item: any, event: any) {
		var count = 0;
		for (let i = 0; i < event.target.value.length; i++) {
			if (event.target.value[i] == ".") {
				count += 1;
			}
		}

		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = "Số lượng không gồm chữ hoặc kí tự đặc biệt";
			this.layoutUtilsService.showErorr(message);
			this.changeDetect.detectChanges();
			return false;
		}
		if (count >= 2) {
			const message = "Số lượng không thể có nhiều hơn 2 dấu .";
			this.layoutUtilsService.showErorr(message);
			return false;
		}

		return true;
	}

	selectedLoaiPhieu(event) {
		this.tmpChiTietKhoXuatKho = [];
		this.tmpChiTietKhoXuatKho = [...this.tmpChiTietKhoXuatKho];

		const _applySelectedColumns: string[] = [];

		if (event.value == this.__THEOYEUCAU) {
			this.columnExtend_DNXK.forEach((element) => {
				this.availableColumns.splice(5, 0, element);
			});
			this.selectedColumns = new SelectionModel<any>(
				true,
				this.availableColumns
			);
		} else {
			this.columnExtend_DNXK.forEach((element) => {
				let index = this.availableColumns.findIndex(
					(x) => x.name == element.name
				);
				if (index > -1) this.availableColumns.splice(index, 1);
			});
			this.selectedColumns = new SelectionModel<any>(
				true,
				this.availableColumns
			);
		}

		if (event.value == this.__THEOKHGH) {
			this.columnExtend_KHGH.forEach((element) => {
				this.availableColumns.splice(5, 0, element);
			});
			this.selectedColumns = new SelectionModel<any>(
				true,
				this.availableColumns
			);
		} else {
			this.columnExtend_KHGH.forEach((element) => {
				let index = this.availableColumns.findIndex(
					(x) => x.name == element.name
				);
				if (index > -1) this.availableColumns.splice(index, 1);
			});
			this.selectedColumns = new SelectionModel<any>(
				true,
				this.availableColumns
			);
		}

		if (event.value == this.__THEOYEUCAU) {
			this.selectedColumns.selected.forEach((col) => {
				let index2 = this.columnExtend_KHGH.findIndex(
					(b) => b.name == col.name
				);
				if (index2 == -1) _applySelectedColumns.push(col.name);
			});
		}

		if (event.value == this.__THEOKHGH) {
			this.selectedColumns.selected.forEach((col) => {
				let index1 = this.columnExtend_DNXK.findIndex(
					(a) => a.name == col.name
				);
				if (index1 == -1) _applySelectedColumns.push(col.name);
			});
		}

		if (event.value == this.__LOAIKHAC || event.value == "") {
			this.selectedColumns.selected.forEach((col) => {
				let index1 = this.columnExtend_DNXK.findIndex(
					(a) => a.name == col.name
				);
				let index2 = this.columnExtend_KHGH.findIndex(
					(b) => b.name == col.name
				);
				if (index1 == -1 && index2 == -1)
					_applySelectedColumns.push(col.name);
			});
		}

		this.displayedColumns = _applySelectedColumns;
		this.changeDetect.detectChanges();
	}

	// 	choPhepXuatKho(IdHH: number, IdKho: number, IdSoLo:number){
	// 		this.dsTonKho.forEach(x => {
	// 			if(x.Id_HH == IdHH && x.Id_Kho == IdKho && x.Id_Lo == IdSoLo){
	// it
	// 			}
	// 		});
	// 	}

	copyItem(item: any) {
		let _ele = this.createElementCT(
			item,
			0,
			this.setListKhoHH(item.IdHh),
			this.setListLotHH(item.IdHh, 0),
			0,
			0
		);
		_ele.Soluongthucnhan = 0;
		this.tmpChiTietKhoXuatKho.push(_ele);
		let tmp = this.tmpChiTietKhoXuatKho;
		this.tmpChiTietKhoXuatKho = [];
		this.tmpChiTietKhoXuatKho = [...tmp];
		this.changeDetect.detectChanges();
	}

	kiemTraDaChonChua(item: any, Id_Kho: number) {
		let record = 0;
		this.tmpChiTietKhoXuatKho.forEach((x) => {
			if (
				item.IdHh == x.IdHh &&
				x.IdKho == Id_Kho &&
				this.disabledAllDSSoLo(item, Id_Kho, x.ListSoLo)
			) {
				record++;
			}
			// Nếu Id_Kho = 0 là chưa chọn gì
		});

		if (record > 0) return true;
		return false;
	}

	disabledAllDSSoLo(item: any, Id_Kho: any, listSoLo: any[]) {
		let flag = true;
		for (let a = 0; a < listSoLo.length; a++) {
			if (!this.kiemTraDaChonChuaLot(item, Id_Kho, listSoLo[a].Id_Lot)) {
				flag = false;
				break;
			}
		}
		return flag;
	}

	kiemTraDaChonChuaLot(item: any, Id_Kho: any, Id_Lot: number) {
		let record = 0;
		this.tmpChiTietKhoXuatKho.forEach((x) => {
			if (item.IdHh == x.IdHh && x.IdKho == Id_Kho && x.IdLo == Id_Lot) {
				record++;
			}
		});

		if (record > 0) return true;
		return false;
	}

	checkSoLuong(item: any) {
		if (
			item.Soluongthucxuat <= 0 ||
			item.Soluongthucxuat > item.Soluongthucnhan
		)
			return true;
		return false;
	}

	async layDanhSachHangHoaTonKhoHienTai() {
		let res = await this.DungChungService.layDanhSachHangHoaTonKhoHienTai().toPromise();
		if (res && res.status == 1) {
			this.data_khotonkho_hientai = res.data;
			if (this.KhoXuatKhoItem.IdXk > 0) {
				this.tmpChiTietKhoXuatKho.forEach((a) => {
					a.Tongsoluongthucnhan = 0;

					let data_cunghhkho = this.tmpChiTietKhoXuatKho.filter(
						(x) => x.IdHh == a.IdHh && x.IdKho == a.IdKho
					);
					let sum = 0;
					data_cunghhkho.forEach((x) => {
						sum += this.laySoLuongSoLoTu_DataKhoListSolo(
							x.IdHh,
							x.IdKho,
							x.IdLo,
							x.ViTriKho,
							true
						);
					});
					if (sum > 0) a.Tongsoluongthucnhan = sum;
				});
				this.tmpChiTietKhoXuatKho = [...this.tmpChiTietKhoXuatKho];
				this.changeDetect.detectChanges();
			}
		} else {
			this.layoutUtilsService.showErorr(res.error.message);
		}
	}

	laySoLuongSoLoTu_DataKhoListSolo(
		idhh: number,
		idkho: number,
		idlo: number,
		VTK: string,
		KhongTinhList: boolean = false
	) {
		let tmp = this.data_khotonkho_hientai;
		let sum = 0;
		let a = this.data_khotonkho_hientai.findIndex((x) => x.Id_HH == idhh);
		if (a > -1) {
			let b = tmp[a].Kho.findIndex((x) => x.Id_Kho == idkho);
			if (b > -1) {
				let c = tmp[a].Kho[b].Lot.findIndex((x) => x.Id_Lot == idlo);
				if (c > -1) {
					let d = tmp[a].Kho[b].Lot[c].ListVTK.findIndex(
						(x) => x.VTK == VTK
					);
					if (d > -1) {
						let element = tmp[a].Kho[b].Lot[c].ListVTK[d];
						sum = element.SLTon;
						if (!KhongTinhList) {
							this.tmpChiTietKhoXuatKho.forEach((x) => {
								if (
									x.IdLo == tmp[a].Kho[b].Lot[c].Id_Lot &&
									x.IdHh == tmp[a].Id_HH &&
									x.IdKho == tmp[a].Kho[b].Id_Kho &&
									x.ViTriKho ==
									tmp[a].Kho[b].Lot[c].ListVTK[d].VTK
								) {
									sum -= x.Soluongthucxuat;
								}
							});
						}
						return sum;
					}
				}
			}
		}

		return 0;
	}

	isAllSelected() {
		const numSelected = this.selection.selected.length;
		const numRows = this.tmpChiTietKhoXuatKho.length;
		return numSelected === numRows;
	}
	masterToggle() {
		if (this.isAllSelected()) {
			this.selection.clear();
		} else {
			this.tmpChiTietKhoXuatKho.forEach((row) => {
				this.selection.select(row);
			});
		}
	}

	exportExcel() {
		if (this.selection.selected.length == 0) {
			this.layoutUtilsService.showErorr(
				"Vui lòng chọn hàng để xuất file!"
			);
			return;
		}

		if (this.selection.selected.length >= 2) {
			for (let i = 0; i < this.selection.selected.length; i++) {
				if (
					this.selection.selected[i].IdKho !=
					this.selection.selected[0].IdKho
				) {
					this.layoutUtilsService.showErorr(
						"Vui lòng chọn các mặt hàng cùng kho!"
					);
					return;
				}
			}
		}

		if (this.selection.selected.length >= 2) {
			for (let i = 0; i < this.selection.selected.length; i++) {
				if (
					typeof this.selection.selected[i].IdKH !=
					typeof this.selection.selected[0].IdKH ||
					this.selection.selected[i].IdKH !=
					this.selection.selected[0].IdKH
				) {
					this.layoutUtilsService.showErorr(
						"Vui lòng chọn các mặt hàng cùng khách hàng!"
					);
					return;
				}
			}
		}
		//this.exportExcelInfo(null)
	}

	// exportExcelInfo(nccInfo: any){

	// 	let head = [['#', 'Mã hàng', 'Tên hàng', 'Số lô', 'Hạn sử dụng', 'Mã kho','ĐVT','Số lượng','Đơn giá','Thành tiền']]
	// 	let dataTable =[{
	// 		'#': 'A',
	// 		'MaHH': 'B',
	// 		'TenHH': 'C',
	// 		'Solo': 'D',
	// 		'HanSuDung': 'E',
	// 		'MaKho': 'F',
	// 		'TenDVT': 'G',
	// 		'SL': '1',
	// 		'DG': '2',
	// 		'TT': '3'
	// 	}];

	// 	var total = 0;
	// 	for(let i = 0; i < this.selection.selected.length; i++){
	// 		let element = this.selection.selected[i]
	// 		dataTable.push({
	// 			'#' : (i + 2) + '',
	// 			'MaHH': element.MaHH,
	// 			'TenHH': element.TenHH,
	// 			'Solo': element.Solo,
	// 			'HanSuDung': element.HanSuDung == null ? '' : this.getFormatDate(element.HanSuDung),
	// 			'MaKho': element.MaKho,
	// 			'TenDVT': element.TenDvt,
	// 			'SL': this.f_currency_V2(this.formatNumber(element.Soluongthucxuat.toString())),
	// 			'DG': '',
	// 			'TT': ''
	// 		});
	// 	}
	// 	let totalSL = 0;
	// 	var dataRow = [];
	// 	dataTable.forEach((element,index) =>{
	// 		if(index == 0){
	// 			dataRow.push([
	// 				{content: element["#"], styles: { halign: 'center' }},
	// 				{content: element.MaHH, styles: { halign: 'center' }},
	// 				{content: element.TenHH, styles: { halign: 'center' }},
	// 				{content: element.Solo, styles: { halign: 'center' }},
	// 				{content: element.HanSuDung, styles: { halign: 'center' }},
	// 				{content: element.MaKho, styles: { halign: 'center' }},
	// 				{content: element.TenDVT, styles: { halign: 'center' }},
	// 				{content: index == 0 ? '1' : '', styles: { halign: 'center' }},
	// 				{content: index == 0 ? '2' : '', styles: { halign: 'center' }},
	// 				{content: index == 0 ? '3' : '', styles: { halign: 'center' }},
	// 			])
	// 		}
	// 		else{
	// 			totalSL += Number(element.SL);
	// 			dataRow.push([
	// 				{content: index, styles: { halign: 'center' }},
	// 				{content: element.MaHH, styles: { halign: 'left' }},
	// 				{content: element.TenHH, styles: { halign: 'left' }},
	// 				{content: element.Solo, styles: { halign: 'left' }},
	// 				{content: element.HanSuDung, styles: { halign: 'left' }},
	// 				{content: element.MaKho, styles: { halign: 'left' }},
	// 				{content: element.TenDVT, styles: { halign: 'left' }},
	// 				{content: this.f_currency(this.formatNumber(element.SL)), styles: { halign: 'right' }},
	// 				{content: ''},
	// 				{content: ''},
	// 			])
	// 		}
	// 	})
	// 	dataRow.push([
	// 		{content: (''), styles: { halign: 'center' }},
	// 		{content:'Cộng', colSpan: 3, styles: { halign: 'center', fontStyle: 'bold', } },
	// 		{content:''},
	// 		{content:''},
	// 		{content: ``},
	// 		{content: `${totalSL == 0 ? '' : this.f_currency(this.formatNumber('' + totalSL))}`, styles: { halign: 'right' }},
	// 	])

	//
	// 	var doc = new jsPDF();
	// 	this.pdfCustomService.AddFontRoboto(doc);
	// 	let x = 10; let y = 15;
	// 	var xOffset = (doc.internal.pageSize.width / 2 - 10);

	// 	doc.setFontSize(10);
	// 	doc.setFontType("normal");
	// 	doc.text(x,y, 'CÔNG TY TNHH THỰC PHẨM NFC');
	// 	y += 7;
	// 	doc.text(x,y, 'Đường số 8, KCX Nhơn Trạch 1, xã Phước Thiên, huyện Nhơn Trạch, tỉnh Đồng Nai, Việt Nam');
	// 	y += 12;

	// 	doc.setFontType("bold");
	// 	doc.setFontSize(12);
	// 	var textWidth = doc.getStringUnitWidth('PHIẾU XUẤT KHO') * doc.internal.getFontSize() / doc.internal.scaleFactor;
	// 	var textOffset = (doc.internal.pageSize.width - textWidth) / 2;
	// 	doc.text(textOffset, y, 'PHIẾU XUẤT KHO');
	// 	y += 7;

	// 	doc.setFontSize(10);
	// 	doc.setFontType("bolditalic");
	// 	var formatDate = this.getFormatDate(this.KhoXuatKhoItem.NgayXuat).split("/")
	// 	var textWidth = doc.getStringUnitWidth('Ngày ' + formatDate[0] + ' tháng ' + formatDate[1] + ' năm ' + formatDate[2]) * doc.internal.getFontSize() / doc.internal.scaleFactor;
	// 	var textOffset = (doc.internal.pageSize.width - textWidth) / 2;

	// 	doc.text(textOffset, y, 'Ngày ' + formatDate[0] + ' tháng ' + formatDate[1] + ' năm ' + formatDate[2]);
	// 	doc.setFontType("normal");
	// 	doc.text(160, y, 'TK nợ:');
	// 	y += 7;
	// 	var textWidth = doc.getStringUnitWidth('Số: ' + this.KhoXuatKhoItem.SoPhieu) * doc.internal.getFontSize() / doc.internal.scaleFactor;
	// 	var textOffset = (doc.internal.pageSize.width - textWidth) / 2;
	// 	doc.text(textOffset, y, 'Số: ' + this.KhoXuatKhoItem.SoPhieu);
	// 	doc.text(160, y, 'TK có:');
	// 	y += 12;

	//

	// 	let TenKH = this.selection.selected.length > 0 ? (this.selection.selected[0].TenKH ? this.selection.selected[0].TenKH : '') : '';
	// 	let DiaChi = this.selection.selected.length > 0 ? (this.selection.selected[0].DiaChi ? this.selection.selected[0].DiaChi : '') : '';

	// 	doc.text(x,y, '- Họ và tên người nhận hàng: ');
	// 	doc.text(x + 50,y, TenKH);
	// 	y += 7;

	// 	doc.text(x,y, '- Địa chỉ (bộ phận): ');
	// 	doc.text(x + 40,y, DiaChi);
	// 	y += 7;

	// 	doc.text(x,y, '- Lý do xuất: ');
	// 	doc.text(x + 22, y, ''+this.KhoXuatKhoItem.LyDoXuat);
	// 	y += 7;

	// 	doc.text(x,y, '- Xuất tại kho: ');
	// 	doc.text(x + 25, y, ''+ this.selection.selected[0].TenKho);

	// 	doc.text(x + doc.internal.pageSize.width / 2,y, 'Địa điểm: ' + ''); y += 7;

	// 	y +=10;
	// 	(doc as any).autoTable({
	// 		head: head,
	// 		body: dataRow,
	// 		styles: {
	// 			font: 'Roboto-Regular',
	//   			fontStyle: 'normal',
	// 			fontSize: 10,
	// 		},
	// 		headStyles:{
	// 			font: 'Roboto-Regular',
	// 			fontStyle: 'bold',
	// 			fontSize: 11,
	// 		},
	// 		margin: { top: y, left: 10 },
	// 		theme: 'grid'
	// 	})
	// 	y +=15 + (dataRow.length * 10);

	// 	doc.text(x,y, '- Số tiền bằng chữ: ');
	// 	doc.setFontType("normal");
	// 	if(total > 0){
	// 		doc.text(x + 30,y, FunctionPublic.convertCurrencyFromNumToStr(total.toString()));
	// 	}
	// 	y += 7;

	// 	doc.text(x,y, '- Số chứng từ gốc kèm theo: '); y += 10;

	// 	var toDay = new Date();
	// 	var d = toDay.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }).split("/");
	// 	doc.setFontType("italic");
	// 	doc.text(x + 142 , y, 'Ngày ' + d[1] + ' tháng ' + d[0] + ' năm ' + d[2]); y += 10;

	// 	let widthA4 = doc.internal.pageSize.width - 10;
	// 	let posBegin = 10;

	// 	doc.setFontType("bold");
	// 	doc.text(posBegin, y, 'Người lập phiếu'); posBegin = posBegin + widthA4 / 5;
	// 	doc.text(posBegin, y, 'Người nhận hàng'); posBegin = widthA4 / 2;
	// 	doc.text(posBegin, y, 'Thủ kho'); posBegin = posBegin + widthA4 / 5;
	// 	doc.text(posBegin, y, 'Kế toán trưởng'); posBegin = posBegin + widthA4 / 5;
	// 	doc.text(posBegin, y, 'Giám đốc'); posBegin = posBegin + widthA4 / 5;
	// 	posBegin = 13;
	// 	y += 7;

	// 	doc.setFontType("normal");
	// 	doc.text(posBegin, y, '(Ký, họ tên)');  posBegin = posBegin + widthA4 / 5;
	// 	doc.text(posBegin, y, '(Ký, họ tên)');  posBegin = -2 + widthA4 / 2;
	// 	doc.text(posBegin, y, '(Ký, họ tên)');  posBegin = posBegin + 5 + widthA4 / 5;
	// 	doc.text(posBegin, y, '(Ký, họ tên)');  posBegin = posBegin - 5 + widthA4 / 5;
	// 	doc.text(posBegin, y, '(Ký, họ tên)');  posBegin = posBegin + widthA4 / 5;
	// 	y += 40;

	// 	doc.text(10, y, this.KhoXuatKhoItem.TenNguoiTao);
	// 	doc.text( widthA4 / 2 - 10, y, "PHẠM THỊ HỒNG NGỌC");

	// 	//doc.output('dataurlnewwindow')

	// 	// Download PDF document
	// 	doc.save(this.KhoXuatKhoItem.SoPhieu + '_Report.pdf');
	// }

	get_data_export() {
		this.waittingExport = true;
		this.KhoXuatKhoService.danhSachKhachHang_XuatKhoTheoPhieu(
			this.KhoXuatKhoItem.IdXk
		).subscribe((res) => {
			if (res && res.status == 1) {
				this.listXuatKho = res.data;
				if (this.listXuatKho.length > 0) {
					this.exportExcelInfo();
					this.waittingExport = false;
				}
				this.waittingExport = false;
				this.changeDetect.detectChanges();
			} else {
				this.waittingExport = false;
				this.layoutUtilsService.showErorr(
					"Không thể lấy được danh sách xuất kho"
				);
			}
		});
	}

	exportExcelInfo() {
		let item = this.listXuatKho[0];
		// console.log(item);
		// return;
		let head = [
			[
				"#",
				"Mã hàng",
				"Tên hàng",
				"Số lô",
				"Hạn sử dụng",
				"Mã kho",
				"ĐVT",
				"Số lượng",
				"Đơn giá",
				"Thành tiền",
			],
		];
		let dataTable = [
			{
				"#": "A",
				MaHH: "B",
				TenHH: "C",
				Solo: "D",
				HanSuDung: "E",
				MaKho: "F",
				TenDVT: "G",
				SL: "1",
				DG: "2",
				TT: "3",
			},
		];

		var total = 0;
		for (let i = 0; i < item.Childs.length; i++) {
			let element = item.Childs[i];
			dataTable.push({
				"#": i + 2 + "",
				MaHH: element.MaHH,
				TenHH: element.TenHH,
				Solo: element.Solo,
				HanSuDung:
					element.HanSuDung == null
						? ""
						: this.getFormatDate(element.HanSuDung),
				MaKho: item.MaKho,
				TenDVT: element.TenDvt,
				SL: element.Soluongthucxuat,
				DG: "",
				TT: "",
			});
		}
		let totalSL = 0;
		var dataRow = [];
		dataTable.forEach((element, index) => {
			if (index == 0) {
				dataRow.push([
					{ content: element["#"], styles: { halign: "center" } },
					{ content: element.MaHH, styles: { halign: "center" } },
					{ content: element.TenHH, styles: { halign: "center" } },
					{ content: element.Solo, styles: { halign: "center" } },
					{
						content: element.HanSuDung,
						styles: { halign: "center" },
					},
					{ content: element.MaKho, styles: { halign: "center" } },
					{ content: element.TenDVT, styles: { halign: "center" } },
					{
						content: index == 0 ? "1" : "",
						styles: { halign: "center" },
					},
					{
						content: index == 0 ? "2" : "",
						styles: { halign: "center" },
					},
					{
						content: index == 0 ? "3" : "",
						styles: { halign: "center" },
					},
				]);
			} else {
				totalSL += Number(element.SL);
				dataRow.push([
					{ content: index, styles: { halign: "center" } },
					{ content: element.MaHH, styles: { halign: "center" } },
					{ content: element.TenHH, styles: { halign: "center" } },
					{ content: element.Solo, styles: { halign: "center" } },
					{
						content: element.HanSuDung,
						styles: { halign: "center" },
					},
					{
						content: item.MaKho ? item.MaKho : element.MaKho,
						styles: { halign: "center" },
					},
					{ content: element.TenDVT, styles: { halign: "center" } },
					{
						content: this.f_number(element.SL),
						styles: { halign: "right" },
					},
					{ content: "" },
					{ content: "" },
				]);
			}
		});
		dataRow.push([
			{ content: "", styles: { halign: "center" } },
			{
				content: "Cộng",
				colSpan: 3,
				styles: { halign: "center", fontStyle: "bold" },
			},
			{ content: "" },
			{ content: "" },
			{ content: `` },
			{
				content: `${totalSL == 0 ? "" : this.f_number(totalSL)}`,
				styles: { halign: "right" },
			},
		]);

		var doc = new jsPDF();
		this.pdfCustomService.AddFontRoboto(doc);
		let x = 10;
		let y = 15;
		var xOffset = doc.internal.pageSize.width / 2 - 10;

		doc.setFontSize(10);
		doc.setFontType("normal");
		doc.text(x, y, "CÔNG TY TNHH THỰC PHẨM NFC");
		y += 7;
		doc.text(
			x,
			y,
			"Đường số 8, KCX Nhơn Trạch 1, xã Phước Thiên, huyện Nhơn Trạch, tỉnh Đồng Nai, Việt Nam"
		);
		y += 12;

		doc.setFontType("bold");
		doc.setFontSize(12);
		var textWidth =
			(doc.getStringUnitWidth("PHIẾU XUẤT KHO") *
				doc.internal.getFontSize()) /
			doc.internal.scaleFactor;
		var textOffset = (doc.internal.pageSize.width - textWidth) / 2;
		doc.text(textOffset, y, "PHIẾU XUẤT KHO");
		y += 7;

		doc.setFontSize(10);
		doc.setFontType("bolditalic");
		var formatDate = this.getFormatDate(item.NgayXuat).split("/");
		var textWidth =
			(doc.getStringUnitWidth(
				"Ngày " +
				formatDate[0] +
				" tháng " +
				formatDate[1] +
				" năm " +
				formatDate[2]
			) *
				doc.internal.getFontSize()) /
			doc.internal.scaleFactor;
		var textOffset = (doc.internal.pageSize.width - textWidth) / 2;

		doc.text(
			textOffset,
			y,
			"Ngày " +
			formatDate[0] +
			" tháng " +
			formatDate[1] +
			" năm " +
			formatDate[2]
		);
		doc.setFontType("normal");
		doc.text(160, y, "TK nợ:");
		y += 7;
		var textWidth =
			(doc.getStringUnitWidth("Số: " + item.SoPhieu) *
				doc.internal.getFontSize()) /
			doc.internal.scaleFactor;
		var textOffset = (doc.internal.pageSize.width - textWidth) / 2;
		doc.text(textOffset, y, "Số: " + item.SoPhieu);
		doc.text(160, y, "TK có:");
		y += 12;

		doc.text(x, y, "- Họ và tên người nhận hàng: ");
		doc.text(x + 50, y, item.TenKH);
		y += 7;

		doc.text(x, y, "- Địa chỉ (bộ phận): ");
		doc.text(x + 30, y, item.DiaChi);
		y += 7;

		doc.text(x, y, "- Lý do xuất: ");
		doc.text(x + 22, y, "" + item.LyDoXuat);
		y += 7;

		doc.text(x, y, "- Xuất tại kho: ");
		doc.text(x + 25, y, "" + item.TenKho);

		doc.text(x + doc.internal.pageSize.width / 2, y, "Địa điểm: " + "");
		y += 7;

		y += 10;
		(doc as any).autoTable({
			head: head,
			body: dataRow,
			styles: {
				font: "Roboto-Regular",
				fontStyle: "normal",
				fontSize: 10,
			},
			headStyles: {
				font: "Roboto-Regular",
				fontStyle: "bold",
				fontSize: 11,
			},
			margin: { top: y, left: 10 },
			theme: "grid",
		});
		y += 15 + dataRow.length * 10;

		doc.text(x, y, "- Số tiền bằng chữ: ");
		doc.setFontType("normal");
		if (total > 0) {
			doc.text(
				x + 30,
				y,
				FunctionPublic.convertCurrencyFromNumToStr(total.toString())
			);
		}
		y += 7;

		doc.text(x, y, "- Số chứng từ gốc kèm theo: ");
		y += 10;

		var toDay = new Date();
		var d = toDay
			.toLocaleDateString("en-US", {
				month: "2-digit",
				day: "2-digit",
				year: "numeric",
			})
			.split("/");
		doc.setFontType("italic");
		doc.text(
			x + 142,
			y,
			"Ngày " + d[1] + " tháng " + d[0] + " năm " + d[2]
		);
		y += 10;

		let widthA4 = doc.internal.pageSize.width - 10;
		let posBegin = 10;

		doc.setFontType("bold");
		doc.text(posBegin, y, "Người lập phiếu");
		posBegin = posBegin + widthA4 / 5;
		doc.text(posBegin, y, "Người nhận hàng");
		posBegin = widthA4 / 2;
		doc.text(posBegin, y, "Thủ kho");
		posBegin = posBegin + widthA4 / 5;
		doc.text(posBegin, y, "Kế toán trưởng");
		posBegin = posBegin + widthA4 / 5;
		doc.text(posBegin, y, "Giám đốc");
		posBegin = posBegin + widthA4 / 5;
		posBegin = 13;
		y += 7;

		doc.setFontType("normal");
		doc.text(posBegin, y, "(Ký, họ tên)");
		posBegin = posBegin + widthA4 / 5;
		doc.text(posBegin, y, "(Ký, họ tên)");
		posBegin = -2 + widthA4 / 2;
		doc.text(posBegin, y, "(Ký, họ tên)");
		posBegin = posBegin + 5 + widthA4 / 5;
		doc.text(posBegin, y, "(Ký, họ tên)");
		posBegin = posBegin - 5 + widthA4 / 5;
		doc.text(posBegin, y, "(Ký, họ tên)");
		posBegin = posBegin + widthA4 / 5;
		y += 40;

		doc.text(10, y, item.TenNguoiTao);
		doc.text(widthA4 / 2 - 10, y, "TRẦN THỊ THƯƠNG");

		//doc.output('dataurlnewwindow')

		// Download PDF document
		doc.save(item.SoPhieu + "_Report.pdf");
	}

	isCreatedAndImplementerUser() {
		var idUser = "";
		this.tokenStorage.getIDUser().subscribe((t) => {
			idUser = t;
		});
		var __createdUser = this.KhoXuatKhoItem.Nguoitao;
		var __listImplementer = this.KhoXuatKhoItem.DSNguoiThucHien;
		if (+idUser == __createdUser || __listImplementer.indexOf(+idUser) > -1)
			return true;
		return false;
	}

	updateStateConfirmTMP() {
		this.KhoXuatKhoService.updateStateConfirmTMP(
			this.KhoXuatKhoItem.SoPhieu
		).subscribe((res) => {
			if (res && res.status == 1) {
				this.layoutUtilsService.showInfo(
					"Xác nhận xuất khỏi vị trí kho thành công."
				);
				this.KhoXuatKhoItem.TinhTrang = "KHOXK_HOANTAT";
				this.KhoXuatKhoItem.DescTinhTrang = "Hoàn tất";
				this.KhoXuatKhoForm.controls["TINHTRANG"].setValue(
					"KHOXK_HOANTAT"
				);
				this.KhoXuatKhoForm.controls["DESCTINHTRANG"].setValue(
					"Hoàn tất"
				);
				this.changeDetect.detectChanges();
			} else {
				this.layoutUtilsService.showErorr(
					"Xác nhận xuất khỏi vị trí kho thất bại."
				);
			}
		});
	}

	openXuatKho() {
		const dialogRef = this.dialog.open(KhoXuatPageFileComponent, {
			data: {
				Id: this.KhoXuatKhoItem.IdXk,
			},
			maxHeight: "90vh",
			width: "70vw",
		});
		dialogRef.afterClosed().subscribe((res) => {
			if (res == undefined || res == null) {
				return;
			} else {
			}
		});
	}

	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return "0,00";
		return new Intl.NumberFormat("de-DE", {
			style: "decimal",
			currency: "VND",
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		}).format(Number(value));
	}

	f_number(item: any = "0.00") {
		return FunctionPublic.F_NUMBER(item);
	}

	getListDNXKSelected() {
		var list = this.tmpChiTietKhoXuatKho.map((x) => {
			var rObj = {};
			rObj["IdDNXK"] = x.IdDNXK;
			rObj["SoPhieuDNXK"] = x.SoPhieuDNXK;
			return rObj;
		});
		var unique = [];
		list.forEach((x) => {
			if (unique.filter((a) => a.IdDNXK == x["IdDNXK"]).length == 0)
				unique.push(x);
		});
		return unique;
	}

	open_dialog_detail_dnxk(__iddn: number) {
		setTimeout(() => {
			this.openDialog = true;
			this.KhoDeNghiXuatKhoService.detail(__iddn).subscribe((res) => {
				if (res.status == 1) {
					const dialogRef = this.dialog.open(
						KhoDeNghiXuatKhoDialogDetailComponent,
						{
							data: {
								data: res.data,
								canEdit: false,
							},
							maxHeight: "90vh",
							width: "90vw",
						}
					);
					dialogRef.afterClosed().subscribe((res) => {
						setTimeout(() => {
							this.openDialog = false;
						}, 50);
					});
				} else {
					this.openDialog = false;
					this.layoutUtilsService.showErorr(res.error.message);
				}
			});
		}, 100);
	}

	get_name_customer() {
		var lCustomer = this.tmpChiTietKhoXuatKho
			.map((x) => x.TenKH)
			.filter((v, i, a) => a.indexOf(v) === i);
		if (lCustomer.length == 0) return "";
		return lCustomer.join(", ").toString();
	}

	get_address_customer() {
		var lCustomer = this.tmpChiTietKhoXuatKho
			.map((x) => x.DiaChi)
			.filter((v, i, a) => a.indexOf(v) === i);
		if (lCustomer.length == 0) return "";
		return lCustomer.join(", ").toString();
	}

	open_dialog_detail_dhb(__iddn: number) {
		this.openDialog = true;
		this.serviceKH.detailOrder(__iddn).subscribe((res) => {
			if (res.status == 1) {
				const dialogRef = this.dialog.open(
					KDDatHangEditComponent,
					{
						data: {
							data: res.data,
							chi_tiet: true
						},
						maxHeight: "90vh",
						width: "90vw",
					}
				);
				dialogRef.afterClosed().subscribe((res) => {
					setTimeout(() => {
						this.openDialog = false;
					}, 50);
				});
			} else {
				this.openDialog = false;
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}

	get_xuat_tai_kho() {
		return this.tmpChiTietKhoXuatKho.length > 0 ? [...new Set(this.tmpChiTietKhoXuatKho.map(x => x.TenKho))].join(", ") : "";
	}

	sum_so_luong() {
		return this.tmpChiTietKhoXuatKho.length > 0 ? this.tmpChiTietKhoXuatKho.map(x => Number(x.Soluongthucxuat)).reduce((a, b) => a + b) : 0;
	}

	get_date_xuat_kho() {
		var date = new Date(this.KhoXuatKhoForm.controls['NGAYXUATKHO'].value);
		return "Ngày " + ("0" + date.getDate().toString()).slice(-2) + " tháng " + ("0" + (date.getMonth() + 1).toString()).slice(-2) + " năm " + date.getFullYear();
	}

	downloadFile(id: number, item: FileImport) {
		if (id > 0) {
			this.KhoXuatKhoService.download(id).subscribe(
				(blob) => {
					var downloadLink = document.createElement("a");
					var url = URL.createObjectURL(blob);
					downloadLink.href = url;
					downloadLink.download = this.KhoXuatKhoForm.controls['FILENAME'].value;
					document.body.appendChild(downloadLink);
					downloadLink.click();
					document.body.removeChild(downloadLink);
				}
			);
		} else {
			let objectURL;
			const file = item.fileByte;
			objectURL = URL.createObjectURL(file);
			var downloadLink = document.createElement("a");
			downloadLink.href = objectURL;
			downloadLink.download = item.filename;
			document.body.appendChild(downloadLink);
			downloadLink.click();
			document.body.removeChild(downloadLink);
		}
	}

	getTotalColspanMer(index: number, column: string) {
		var item = this.tmpChiTietKhoXuatKho[index];
		const COLUMN_SLDN = "SLDN";
		const COLUMN_QUANTITY = "SL";
		const COLUMN_MACHINE = "SoMay";
		const COLUMN_LOT = "IdLo";
		var listLikeMer = [];
		var indexFirst = -1;
		this.tmpChiTietKhoXuatKho.forEach((x, index) => {
			let flag = false;
			if (x[column] == item[column] && x.IdHh == item.IdHh) {
				switch (column) {
					case COLUMN_SLDN: {
						const COLUMN_DNXK = "SoPhieuDNXK";
						if (x[COLUMN_DNXK] == item[COLUMN_DNXK]) flag = true;
						break;
					}
					case COLUMN_QUANTITY: {
						if (x[COLUMN_LOT] == item[COLUMN_LOT]) {
							if (item[COLUMN_MACHINE] && item[COLUMN_MACHINE] == x[COLUMN_MACHINE])
								flag = true;
							if (!item[COLUMN_MACHINE] && !x[COLUMN_MACHINE])
								flag = true;
						}
						break;
					}
					case COLUMN_MACHINE: {
						if (x[COLUMN_LOT] == item[COLUMN_LOT]) flag = true;
						break;
					}
					default: {
						flag = true;
					}
				}
			}
			if (flag) {
				listLikeMer.push(x);
				if (indexFirst == -1) indexFirst = index;
			}
		});
		if (listLikeMer.length > 1) {
			if (indexFirst == index) return listLikeMer.length;
			return 0;
		}
		return 1;
	}
	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges();
		}
	}
	// .. Tag kho ========================================================================
	// .. Danh sách tag kho
	ListTagKho() {
		this.DungChungService.listTagKho().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listTagFull = res.data;
				this.changeDetectView()
			};
		});
	}
	// .. Hàm lấy mã màu từ tên tag kho
	getBgColorTag(tag: string){
		var _item = this.listTagFull.find(_x => _x.tagkho == tag);
		return _item == null? '#ccc' : _item.BackgroundColor;
	}
	// ' Hàm format date sang định dạng text dd/MM/yyyy hh:mm '
	strDate(d){
		if (!d) return '';
		var date  = new Date(d);
		var day   = ("00" + date.getDate()).slice(-2);
  		var month = ("00" + (date.getMonth() + 1)).slice(-2);
  		var year  = date.getFullYear();
		var hours = ("00" + date.getHours()).slice(-2);
		var minutes = ("00" + date.getMinutes()).slice(-2);
		return day + "/" + month + "/" + year + " " + hours + ":" + minutes;
	}
}
